<template lang="html">
  <div id="home-page" data-aos="fade-in" data-aos-duration="1000">

    <!-- Banners  -->
    <section class="banners-section">
      <swiper class="swiper" :options="bannersOptions">
        <swiper-slide>
          <div class="img-banner desktop" v-bind:style="{ backgroundImage: 'url(public/images/pages/home/banner-1.jpg)' }"></div>
          <div class="img-banner mobile" v-bind:style="{ backgroundImage: 'url(public/images/pages/home/banner-1-m.jpg)' }"></div>
        </swiper-slide>
      </swiper>

      <div class="search-box-container">
        <div class="container">
          <BoxSearchComponent></BoxSearchComponent>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Brands & business allies -->
    <section class="brands-section">
      <div class="container med-container">
        <div class="d-block mb-3 mb-sm-4 text-center">
          <h2 class="title-s1">MARCAS Y ALIADOS COMERCIALES</h2>
        </div>

        <div class="box-brands">
          <swiper class="swiper" :options="brandsOptions">
            <swiper-slide v-for="(bh, bhInx) in brands" :key="'bhInx-'+bhInx">
              <div class="box-logo">
                <img :src="bh.imageUrl">
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Promotions -->
    <section class="container med-container promotions-section">
      <div class="row">
        <div class="col-12 text-center mb-3 mb-sm-4 col-title">
          <h2 class="title-s1">PROMOCIONES</h2>
        </div>

        <div class="col-12 col-promotions">
          <swiper class="swiper swiper-st-1" :options="promosOptions">
            <swiper-slide v-for="(ph, phInx) in promotions" :key="'phInx-'+phInx">
              <router-link class="col-12 px-0 box-promo-s1" to="/ofertas/1">
                <div class="placed-backg box" v-bind:style="{ backgroundImage: 'url('+ph.imageUrl+')' }">
                  <div class="inside">
                    <div class="b-text">
                      <p v-html="ph.title"></p>
                    </div>
                  </div>
                </div>
              </router-link>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Newsletter -->
    <section class="newsletter-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h3>SUSCRÍBETE A NUESTRO BOLETÍN</h3>
          </div>

          <div class="col-lg col-label">
            Y RECIBE DESCUENTOS:
          </div>

          <div class="col-lg col-form">
            <b-form inline @submit="onSubmitNewsletter">
              <b-form-input
                placeholder="EMAIL"
                v-model="newsletterForm.email"
                required
              ></b-form-input>

              <b-form-input
                placeholder="TU NOMBRE"
                v-model="newsletterForm.name"
                required
              ></b-form-input>

              <b-button class="t-150 btn-send" type="submit">INSCRIBIRME</b-button>
            </b-form>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Blog -->
    <section class="blog-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">NUESTRAS MEJORES OFERTAS</h2>
          </div>

          <div class="col-12">
            <swiper class="swiper swiper-st-1" :options="blogOptions">
              <swiper-slide v-for="(ah, ahInx) in blog" :key="'ahInx-'+ahInx">
                <div class="col-12 px-0 box-article-s1">
                  <router-link class="box" to="/ofertas/1">
                    <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+ah.imageUrl+')' }"></div>

                    <div class="box-info">
                      <h5 class="title">{{ ah.title }}</h5>

                      <div class="b-text" v-html="ah.text"></div>
                    </div>
                  </router-link>
                </div>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

  </div>
</template>

<script>
import BoxSearchComponent from './trips/box-search-component.vue';
export default {
  components: {
    BoxSearchComponent
  },

  data() {
    return {
      newsletterForm: {
        email: null,
        name: null,
      },

      brands: [
        { imageUrl: 'public/images/pages/home/brand-1.png' },
        { imageUrl: 'public/images/pages/home/brand-2.png' },
        { imageUrl: 'public/images/pages/home/brand-3.png' },
        { imageUrl: 'public/images/pages/home/brand-4.png' },
      ],

      promotions: [
        { imageUrl: 'public/images/pages/promotions/promo-1.jpg', title: `10%<br />MES PATRIO` },
        { imageUrl: 'public/images/pages/promotions/promo-2.jpg', title: `3er<br />Pasajero gratis` },
        { imageUrl: 'public/images/pages/promotions/promo-3.jpg', title: `Reserva para<br />Navidad y ahorra` },
      ],

      blog: [
        { imageUrl: 'public/images/pages/blog/article-1.jpg',
          title: 'Nueva ruta conecta Guadalajara y Los Mochis',
          text: `
            En un esfuerzo por fortalecer las opciones de
            transporte y expandir las conexiones regionales, se ha
            anunciado la apertura de una nueva ruta que unirá la
            ciudad de Guadalajara, Jalisco, con Los Mochis,
            Sinaloa.<br />
            <br />
            Esta nueva conexión promete ser un importante
            impulso tanto para el turismo como para el comercio
            entre estas dos vibrantes ciudades.
          `
        },
        { imageUrl: 'public/images/pages/blog/article-2.jpg',
          title: 'Ahorra reservando con anticipación para la navidad',
          text: `
            Con la temporada navideña acercándose rápidamente,
            muchos están comenzando a planificar sus festividades
            y viajes.<br />
            <br />
            Este año, hacer tus reservas con anticipación puede
            ofrecer no solo tranquilidad sino también significativos
            ahorros económicos.
          `
        },
      ],

      // == Carousels options ==
      bannersOptions: {
        loop: true,
        effect: 'fade',

        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
      },

      brandsOptions: {
        speed: 700,
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,

        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },

        breakpoints: {
          1200: {
            slidesPerView: 4,
            spaceBetween: 30,

            autoplay: {
              delay: 400000,
              disableOnInteraction: false
            },
          },
          576: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1: {
            slidesPerView: 2,
            spaceBetween: 20,

            autoplay: {
              delay: 4000,
              disableOnInteraction: false
            },
          },
        }
      },

      promosOptions: {
        slidesPerView: 3,
        spaceBetween: 30,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          1510: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        }
      },

      blogOptions: {
        slidesPerView: 2,
        spaceBetween: 30,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        }
      }
      // == ==
    }
  },

  methods: {
    onSubmitNewsletter(event) {
      event.preventDefault();
    },
  },
}
</script>
